import { render, staticRenderFns } from "./DispatcherEvents.vue?vue&type=template&id=e2e7f254&scoped=true&"
import script from "./DispatcherEvents.vue?vue&type=script&lang=js&"
export * from "./DispatcherEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e7f254",
  null
  
)

export default component.exports